import { render } from "./PDO3.vue?vue&type=template&id=d630f412"
import script from "./PDO3.vue?vue&type=script&lang=js"
export * from "./PDO3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__